import { AnalyticsEvent, AnalyticsEventName } from '../events';

type TranslateLegacyEventEventsProperties = (properties: AnalyticsEvent['properties']) => AnalyticsEvent['properties'];
const translateLegacyEventEventsProperties: TranslateLegacyEventEventsProperties = (properties) => {
  const { broadcastId, groupId, isEmbeddable, ...otherProperties } = properties;

  return {
    ...otherProperties,
    broadcast_id: broadcastId,
    group_id: groupId,
    embeddable_player: isEmbeddable,
  };
};

const translateLegacyEventsProperties = (event: AnalyticsEvent): AnalyticsEvent['properties'] => {
  let translatedProperties = event.properties;

  if (event.name === AnalyticsEventName.EventsPageLoaded) {
    translatedProperties = translateLegacyEventEventsProperties(translatedProperties);
  }

  return translatedProperties;
};

export default translateLegacyEventsProperties;
